import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OpcionesPersonalizadoTipoCampoModel, PersonalizadoModel } from '../models/campos-informacion-cliente.types';

@Injectable({
  providedIn: 'root'
})
export class CamposInformacionClienteService {

  constructor(
    private _http: HttpClient,
  ) { }



  getTipoCampo() {
    return this._http.get<OpcionesPersonalizadoTipoCampoModel[]>(
      `${environment.API_URL}/TipoCampo/`
    );
  }

  getCampoInformacionCliente() {
    return this._http.get<PersonalizadoModel[]>(
      `${environment.API_URL}/Personalizados/`
    );
  }

  getCampoInformacionClienteById(id: number) {
    return this._http.get<PersonalizadoModel>(
      `${environment.API_URL}/Personalizados/${id}`
    );
  }

  postCampoInformacionCliente(data: PersonalizadoModel) {
    return this._http.post(
      `${environment.API_URL}/Personalizados`,
      data
    );
  }

  putCampoInformacionCliente(id: number, data: PersonalizadoModel) {
    return this._http.put(
      `${environment.API_URL}/Personalizados/${id}`,
      data
    );
  }

  deleteCampoInformacionCliente(id: number) {
    return this._http.delete(
      `${environment.API_URL}/Personalizados/${id}`
    );
  }
}
